import React from 'react';

const DeletedUserSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" width="30" height="30">
    <defs>
      <linearGradient id="userGrad" x1="0%" y1="0%" x2="0%" y2="100%">
        <stop offset="0%" stopColor="#9e9e9e" />
        <stop offset="100%" stopColor="#757575" />
      </linearGradient>
      <linearGradient id="xGrad" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#ef4444" />
        <stop offset="100%" stopColor="#dc2626" />
      </linearGradient>
    </defs>

    {/* User silhouette circle background */}
    <circle cx="32" cy="32" r="28" fill="#e0e0e0" stroke="#bdbdbd" strokeWidth="2" />

    {/* User head */}
    <circle cx="32" cy="24" r="9" fill="url(#userGrad)" opacity="0.6" />

    {/* User body */}
    <path
      d="M 32 33 Q 20 35, 15 45 Q 14 48, 14 52 L 50 52 Q 50 48, 49 45 Q 44 35, 32 33 Z"
      fill="url(#userGrad)"
      opacity="0.6"
    />

    {/* Diagonal strike lines creating X */}
    <g>
      {/* First diagonal line */}
      <line x1="18" y1="18" x2="46" y2="46" stroke="url(#xGrad)" strokeWidth="4" strokeLinecap="round" />

      {/* Second diagonal line */}
      <line x1="46" y1="18" x2="18" y2="46" stroke="url(#xGrad)" strokeWidth="4" strokeLinecap="round" />

      {/* White outline for contrast */}
      <line x1="18" y1="18" x2="46" y2="46" stroke="white" strokeWidth="6" strokeLinecap="round" opacity="0.3" />
      <line x1="46" y1="18" x2="18" y2="46" stroke="white" strokeWidth="6" strokeLinecap="round" opacity="0.3" />
    </g>

    {/* Outer circle for deleted status */}
    <circle cx="32" cy="32" r="28" fill="none" stroke="#ef4444" strokeWidth="2" opacity="0.5" />

    {/* Small deletion indicator badge */}
    <circle cx="50" cy="14" r="6" fill="#ef4444" stroke="#dc2626" strokeWidth="1.5" />
    <g stroke="white" strokeWidth="2" strokeLinecap="round">
      <line x1="48" y1="14" x2="52" y2="14" />
    </g>
  </svg>
);

export default DeletedUserSvg;
